<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 3C3 1.34315 4.34315 0 6 0H18C19.6569 0 21 1.34315 21 3V21.7902C21 23.3198 19.3527 24.2832 18.0195 23.5333L12 20.1473L5.98052 23.5333C4.64732 24.2832 3 23.3198 3 21.7902V3ZM6 2C5.44772 2 5 2.44772 5 3V21.7902L12 17.8527L19 21.7902V3C19 2.44772 18.5523 2 18 2H6Z"
      :fill="color"
    />
    <path
      d="M17 8.80705L13.4098 8.48607L12 5L10.5902 8.48607L7 8.80705L9.72332 11.3021L8.90331 15L12 13.0252L15.0967 15L14.2767 11.3021L17 8.80705Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PremiumOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
